export default "__VITE_ASSET__B4kgz4Am__"